import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"
import ModuloEnum from "@/core/utils/ModuloEnum"

const componentRouterView = {
    render(c) {
        return c("router-view")
    },
}

const createRegisterRoute = ({
    baseUrl,
    name,
    titleList,
    listComponent,
    menu,
    othersRoutes = [],
}) => ({
    path: baseUrl,
    component: componentRouterView,
    children: [
        {
            path: "/",
            name: `listar${name}`,
            meta: { description: titleList, menu },
            component: listComponent,
        },
        ...othersRoutes,
    ],
})

const routes = {
    path: "/cadastros",
    component: componentRouterView,
    meta: {
        permissoesEspeciais:[PrivilegiosEnum.CAD_ESSENC_ACESSAR, PrivilegiosEnum.CAD_ESSENC_PATRIMONIO_ACESSAR,PrivilegiosEnum.CAD_ESSENC_ALMOXARIFADO_ACESSAR],
        modulo: ModuloEnum.NAO_NECESSITA_VERIFICACAO,
        moduleName: "Cadastros Essenciais",
        icon: "card-list",
        sistema: 2,
    },
    children: [
        createRegisterRoute({
            baseUrl: "tipo-empenho",
            name: "TipoEmpenho",
            titleList: "Tipo empenho",
            listComponent: () => import("./tipo-empenho/TipoEmpenhoList.vue"),
            menu: { name: "Tipo Empenho", permissao: PrivilegiosEnum.ESSENCIAIS_ALMOXARIFADO_TIPO_EMPENHO },
        }),
        createRegisterRoute({
            baseUrl: "tipo-aquisicao-ibp",
            name: "TipoAquisicaoIBP",
            titleList: "Tipo aquisição",
            listComponent: () =>
                import("./tipo-aquisicao-ibp/TipoAquisicaoIBPList.vue"),
            menu: { name: "Tipo aquisição", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),
        createRegisterRoute({
            baseUrl: "prioridade",
            name: "Prioridade",
            titleList: "Prioridade",
            listComponent: () => import("./prioridade/PrioridadeList.vue"),
            menu: { name: "Prioridade", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),
        createRegisterRoute({
            baseUrl: "tipo-status",
            name: "TipoStatus",
            titleList: "Tipo status",
            listComponent: () => import("./tipo-status/TipoStatusList.vue"),
            menu: { name: "Tipo Status", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),
        createRegisterRoute({
            baseUrl: "tipo-empresa",
            name: "TipoEmpresa",
            titleList: "Tipo Empresa",
            listComponent: () => import("./tipo-empresa/TipoEmpresaList.vue"),
            menu: { name: "Tipo Empresa", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),
        createRegisterRoute({
            baseUrl: "tipo-produto",
            name: "TipoProduto",
            titleList: "Tipo de produto",
            listComponent: () => import("./tipo-produto/TipoProdutoList.vue"),
            menu: { name: "Tipo de produto", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),
        createRegisterRoute({
            baseUrl: "tipo-tarefa",
            name: "TipoTarefa",
            titleList: "Tipo tarefa",
            listComponent: () => import("./tipo-tarefa/TipoTarefaList.vue"),
            menu: { name: "Tipo Tarefa", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),
        createRegisterRoute({
            baseUrl: "comissao",
            name: "Comissao",
            titleList: "Comissão",
            listComponent: () => import("./comissao/ComissaoList.vue"),
            menu: { name: "Comissão", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),
        createRegisterRoute({
            baseUrl: "natureza-despesa",
            name: "NaturezaDespesa",
            titleList: "Natureza de despesa",
            listComponent: () => import("./natureza-despesa/NaturezaDespesaList.vue"),
            menu: { name: "Natureza de despesa", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),
        createRegisterRoute({
            baseUrl: "pessoa",
            name: "Pessoa",
            titleList: "Pessoa",
            listComponent: () => import("./pessoa/PessoaList.vue"),
            menu: { name: "Pessoa", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),
        createRegisterRoute({
            baseUrl: "local-armazenamento",
            name: "LocalArmazenamento",
            titleList: "Local Armazenamento",
            listComponent: () =>
                import("./local-armazenamento/LocalArmazenamentoList.vue"),
            menu: { name: "Local Armazenamento", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),
        createRegisterRoute({
            baseUrl: "tipo-baixa",
            name: "TipoBaixa",
            titleList: "Tipo de baixa",
            listComponent: () => import("./tipo-baixa/TipoBaixaList.vue"),
            menu: { name: "Tipo Baixa", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),
        createRegisterRoute({
            baseUrl: "grupo-tipo-baixa",
            name: "GrupoTipoBaixa",
            titleList: "Grupo Tipo de baixa ",
            listComponent: () => import("./grupo-tipo-baixa/GrupoTipoBaixaList.vue"),
            menu: { name: "Grupo Tipo Baixa", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),
        createRegisterRoute({
            baseUrl: "tipo-caracteristica",
            name: "TipoCaracteristica",
            titleList: "Tipo Característica",
            listComponent: () => import("./tipo-caracteristica/TipoCaracteristicaList.vue"),
            menu: { name: "Tipo Característica", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),
        createRegisterRoute({
            baseUrl: "tipo-medida",
            name: "TipoMedida",
            titleList: "Tipo de medida",
            listComponent: () => import("./tipo-medida/TipoMedidaList.vue"),
            menu: { name: "Tipo Medida", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),
        createRegisterRoute({
            baseUrl: "grupo-produto",
            name: "GrupoProduto",
            titleList: "Grupo de produto",
            titleCreate: "Grupo de produto >> Cadastrar",
            listComponent: () => import("./grupo-produto/GrupoProdutoList.vue"),
            menu: { name: "Cadastro de Gr/Sub/Cl", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
            othersRoutes: [
            ],
        }),

        createRegisterRoute({
            baseUrl: "banco",
            name: "Banco",
            titleList: "Banco",
            titleCreate: "Banco",
            titleEdit: "Banco",
            listComponent: () => import("@/modules/cadastros/banco/BancoList.vue"),
            menu: { name: "Banco", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),
        createRegisterRoute({
            baseUrl: "classe",
            name: "Classe",
            titleList: "Classe",
            listComponent: () => import("./classe/ClasseList.vue"),
            menu: { name: "Classe", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),
        createRegisterRoute({
            baseUrl: "conta-contabil",
            name: "ContaContabil",
            titleList: "Conta contábil",
            listComponent: () => import("./conta-contabil/ContaContabilList.vue"),
            menu: { name: "Conta contabil", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),
        createRegisterRoute({
            baseUrl: "marca",
            name: "Marca",
            titleList: "Marca",
            listComponent: () => import("./marca/MarcaList.vue"),
            menu: { name: "Marca", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),
        createRegisterRoute({
            baseUrl: "modelo",
            name: "Modelo",
            titleList: "Modelo",
            listComponent: () => import("./modelo/ModeloList.vue"),
            menu: { name: "Modelo", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),
        createRegisterRoute({
            baseUrl: "tipo-documento",
            name: "TipoDocumento",
            titleList: "Tipo de documento",
            listComponent: () => import("./tipo-documento/TipoDocumentoList.vue"),
            menu: { name: "Tipo de Documento", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),

        createRegisterRoute({
            baseUrl: "status-guia-saida",
            name: "StatuGuia",
            titleList: "Status da Guia de Saída",
            listComponent: () => import("@/modules/cadastros/status-guia/StatusGuiaList.vue"),
            menu: { name: "Status da Guia de Saída", permissao: PrivilegiosEnum.STATUS_GUIA_SAIDA_ACESSAR },
        }),
        createRegisterRoute({
            baseUrl: "tipo-estado-conservacao",
            name: "TipoEstadoConservacao",
            titleList: "Estado de conservação",
            titleCreate: "Estado de conservação >> Cadastrar",
            titleEdit: "Estado de conservação >> Editar",
            listComponent: () =>
                import("./tipo-estado-conservacao/TipoEstadoConservacaoList.vue"),
            formComponent: () =>
                import("./tipo-estado-conservacao/TipoEstadoConservacaoForm.vue"),
            menu: { name: "Estado de conservação", permissao: PrivilegiosEnum.TIPO_ESTADO_CONSERVACAO_ACESSAR },
        }),
        createRegisterRoute({
            baseUrl: "tipo-local-armazenamento",
            name: "TipoLocalArmazenamento",
            titleList: "Tipo local de Armazenamento",
            listComponent: () =>
                import("./tipo-local-armazenamento/TipoLocalArmazenamentoList.vue"),
            menu: { name: "Tipo de local de Armazenamento", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),
        createRegisterRoute({
            baseUrl: "tipo-problema",
            name: "TipoProblema",
            titleList: "Tipo de Problema",
            listComponent: () => import("./tipo-problema/TipoProblemaList.vue"),

            menu: { name: "Tipo de Problema", permissao: PrivilegiosEnum.TIPO_PROBLEMA_ACESSAR },
        }),
        createRegisterRoute({
            baseUrl: "unidade-federativa",
            name: "unidade-federativa",
            titleList: "Unidade Federativa",
            listComponent: () => import("./unidadefederativa/UnidadeFederativaList.vue"),
            menu: { name: "Unidade Federativa", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),
        createRegisterRoute({
            baseUrl: "empresa",
            name: "Empresa",
            titleList: "Empresa/Pessoa",
            listComponent: () => import("./empresa/EmpresaList.vue"),
            menu: { name: "Empresa", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),
        createRegisterRoute({
            baseUrl: "produto",
            name: "Produto",
            titleList: "Produto",
            listComponent: () => import("./produto/ProdutoList.vue"),
            menu: { name: "Produto", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),
        createRegisterRoute({
            baseUrl: "especificacao-produto",
            name: "EspecificacaoProduto",
            titleList: "Especificação do produto",
            listComponent: () =>
                import("./especificacao-produto/EspecificacaoProdutoList.vue"),
            menu: { name: "Especificação do produto", permissao: PrivilegiosEnum.ESSENCIAIS_ALMOXARIFADO_ESPECIFICACAO_PRODUTO_ALMOXARIFADO },
        }),
        createRegisterRoute({
            baseUrl: "caracteristica",
            name: "Caracteristica",
            titleList: "Característica",
            listComponent: () => import("./caracteristica/CaracteristicaList.vue"),
            menu: { name: "Característica", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),
        createRegisterRoute({
            baseUrl: "tipo-contrato",
            name: "TipoContrato",
            titleList: "Tipo de Contrato",
            listComponent: () => import("./tipo-contrato/TipoContratoList.vue"),
            menu: { name: "Tipo de Contrato", permissao: PrivilegiosEnum.CONTRATO_ACESSAR },
        }),
        createRegisterRoute({
            baseUrl: "pais",
            name: "pais",
            titleList: "Pais",
            listComponent: () => import("./pais/PaisList.vue"),

            menu: { name: "País", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),
        createRegisterRoute({
            baseUrl: "modalidade-contrato",
            name: "ModalidadeContrato",
            titleList: "Modalidade de Contrato",
            listComponent: () => import("./modalidadecontrato/ModalidadeContratoList.vue"),
            menu: { name: "Modalidade de Contrato", permissao: PrivilegiosEnum.CONTRATO_ACESSAR },
        }),
        createRegisterRoute({
            baseUrl: "grupo-contrato",
            name: "GrupoContrato",
            titleList: "Grupo Contrato",
            listComponent: () => import("./grupocontrato/GrupoContratoList.vue"),
            menu: { name: "Grupo de Contrato", permissao: PrivilegiosEnum.CONTRATO_ACESSAR },
        }),
        createRegisterRoute({
            baseUrl: "tipo-garantia-contrato",
            name: "tipo-garantia-contrato",
            titleList: "Tipo Garantia Contrato",
            listComponent: () => import("./tipo-garantia-contrato/TipoGarantiaContratoList.vue"),
            menu: { name: "Tipo Garantia Contrato", permissao: PrivilegiosEnum.CONTRATO_ACESSAR },
        }),
        createRegisterRoute({
            baseUrl: "garantia-contrato",
            name: "garantia-contrato",
            titleList: "Garantia Contrato",
            listComponent: () => import("./garantia-contrato/GarantiaContratoList.vue"),
            menu: { name: "Garantia Contrato", permissao: PrivilegiosEnum.CONTRATO_ACESSAR },
        }),

        createRegisterRoute({
            baseUrl: "tipo-fiscal",
            name: "tipo-fiscal",
            titleList: "Tipo Fiscal",
            listComponent: () => import("./tipofiscal/TipoFiscalList.vue"),
            menu: { name: "Tipo Fiscal", permissao: PrivilegiosEnum.CONTRATO_ACESSAR },
        }),
        createRegisterRoute({
            baseUrl: "tipo-valor",
            name: "tipo-valor",
            titleList: "Tipo Valor",
            listComponent: () => import("./tipovalor/TipoValorList.vue"),
            menu: { name: "Tipo Valor", permissao: PrivilegiosEnum.CONTRATO_ACESSAR },
        }),
        createRegisterRoute({
            baseUrl: "exercicio-fiscal",
            name: "exerciciofiscal",
            titleList: "Exercício Fiscal",
            listComponent: () => import("./exercicio-fiscal/ExercicioFiscalList.vue"),
            menu: {
                name: "Exercício Fiscal", permissao: PrivilegiosEnum.EXERCICIO_FISCAL_ACESSAR,
            },
        }),

        createRegisterRoute({
            baseUrl: "hierarquia-unidade-administrativa-cadastro",
            name: "hierarquia-unidade-administrativa-cadastro",
            titleList: "Hierarquia Unidade Administrativa",
            listComponent: () => import("@/modules/cadastros/hierarquia-unidade-administrativa/HierarquiaUnidadeAdministrativaList.vue"),
            menu: { name: "Hierarquia Unidade Administrativa", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),

        createRegisterRoute({
            baseUrl: "leitor",
            name: "leitor",
            titleList: "Leitor",
            listComponent: () => import("@/modules/cadastros/leitor/LeitorList.vue"),
            menu: { name: "Leitor", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),
        createRegisterRoute({
            baseUrl: "impressora",
            name: "impressora",
            titleList: "Impressora",
            listComponent: () => import("@/modules/cadastros/impressora/ImpressoraList.vue"),
            menu: { name: "Impressora", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),

        createRegisterRoute({
            baseUrl: "departamento-local-leitor",
            name: "departamentolocalleitor",
            titleList: "Departamento-Local-Leitor",
            listComponent: () => import("@/modules/cadastros/leitor-monitoramento/DepartamentoLocalLeitorMonitoramentoList.vue"),
            menu: { name: "Departamento-Local-Leitor", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),



        createRegisterRoute({
            baseUrl: "unidade-administrativa-cadastro",
            name: "unidade-administrativa-cadastro",
            titleList: "Unidade Administrativa",
            listComponent: () => import("@/modules/cadastros/unid-administrativa/UnidadeAdministrativaList.vue"),
            menu: { name: "Unidade Administrativa", permissao: PrivilegiosEnum.NAO_NECESSITA_PERMISSAO },
        }),

        createRegisterRoute({
            baseUrl: "tipo-orgao",
            name: "tipo-orgao",
            titleList: "Tipo Orgão",
            listComponent: () => import("./tipoorgao/TipoOrgaoList.vue"),
            menu: { name: "Tipo Orgao", permissao: PrivilegiosEnum.CONTRATO_ACESSAR },
        }),
    ],
}

export default routes

